import React from 'react'

import { Chart } from './chart'
import { Table } from './table'

export const ChartTable = (args) => {

    return <figure>
        <div aria-hidden="true"><Chart {...args} /></div>
        <figcaption className="screen-reader-only">
        <Table {...args} />
        </figcaption>
        </figure>
}


// WEBPACK FOOTER //
// ./src/treasury-chart/index.js